import React from 'react';
import { Link } from 'react-router-dom';
import s from './SiteFooter.module.css';
import logoWhite from '../../images/לוגו 7.png';

const NAV_LINKS = [
  { label: 'אודות הסטודיו', target: 'about' },
  { label: 'הגישה שלנו', target: 'approach' },
  { label: 'שירותים', target: 'services' },
  { label: 'פרויקטים', target: 'projects' },
  { label: 'לפני ואחרי', target: 'transformations' },
  { label: 'עיתונות', target: 'press' },
];

export default function SiteFooter({ onOpenLead }) {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <footer className={s.footer}>
      {/* Decorative corner marks */}
      <span className={s.corner} data-corner="tl" />
      <span className={s.corner} data-corner="tr" />

      <div className={s.inner}>
        {/* Top: Logo + nav + contact CTA */}
        <div className={s.top}>
          <div className={s.brand}>
            <img src={logoWhite} alt="Langer Architecture & Design" className={s.logo} />
          </div>

          <nav className={s.nav} aria-label="ניווט תחתון">
            <ul className={s.navList}>
              {NAV_LINKS.map((link) => (
                <li key={link.label}>
                  <button
                    type="button"
                    className={s.navLink}
                    onClick={() => scrollTo(link.target)}
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </nav>

          <div className={s.ctaCol}>
            <button type="button" className={s.cta} onClick={onOpenLead}>
              <span className={s.ctaText}>לשיחת היכרות לחצו כאן</span>
              <span className={s.ctaArrow} aria-hidden="true">←</span>
            </button>

            <address className={s.contact}>
              <a href="tel:0524853300" className={s.contactLink}>052-4853300</a>
              <a href="mailto:Langerarch.studio@gmail.com" className={s.contactLink}>
                Langerarch.studio@gmail.com
              </a>
              <span className={s.contactText}>הכרמים 6, מושב אלוני אבא</span>
            </address>

            <div className={s.socials}>
              <a
                href="https://www.instagram.com/lirit.langer_arch/"
                target="_blank"
                rel="noopener noreferrer"
                className={s.social}
                aria-label="אינסטגרם"
              >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4">
                  <rect x="3" y="3" width="18" height="18" rx="5" />
                  <circle cx="12" cy="12" r="4" />
                  <circle cx="17.5" cy="6.5" r="0.8" fill="currentColor" />
                </svg>
              </a>
              <a
                href="https://www.facebook.com/langershkori/"
                target="_blank"
                rel="noopener noreferrer"
                className={s.social}
                aria-label="פייסבוק"
              >
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M13 22v-8h3l.5-4H13V7.5c0-1.2.4-2 2-2h2V2.2C16.6 2.1 15.6 2 14.4 2 11.9 2 10 3.5 10 6.2V10H7v4h3v8h3z" />
                </svg>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className={s.bottom}>
          <p className={s.copyright}>
            © {new Date().getFullYear()} Langer Architecture &amp; Design
          </p>
          <Link to="/privacy" className={s.privacyLink}>
            מדיניות פרטיות ותנאי שימוש
          </Link>
        </div>
      </div>
    </footer>
  );
}
